import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: ['rating_system_id', 'region', 'platform', 'reason'],
  noSort: ['rating_system_id', 'region', 'platform', 'reason'],
  titles: [store.__('rating'), store.__('region'), store.__('platform'), store.__('reason')],
  _sortField: 'rating_system_id',
  initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    region: Validators.regionTest(store),
    _global: (vals, values) => {
      const error = []
      const countries = store.options.get('Countries')
      const getRegions = (region) => {
        if (!region || !region.length) {
          return ['']
        } else if (region === 'WW') {
          return ['WW']
        }
        const splitregion = (region.charAt(0) === '-' ? region.substring(1) : region).split(',')
        return region.charAt(0) === '-'
          ? countries.map(country => !splitregion
            .find(region => region === country.value) && country.value)
            .filter(result => result && result.length <= 2)
          : splitregion
      }
      const region = vals.get('region') && vals.get('region').length > 0 ? getRegions(vals.get('region')) : ['']

      values.map(v => {
        if ((vals.get('id') && v.id && vals.get('id') === v.id) ||
          (vals.get('control_timestamp') && v.control_timestamp && vals.get('control_timestamp') === vals.control_timestamp)) {
        // same item
        } else {
          if (region.length > 0 && getRegions(v.region).some(r => region.includes(r)) &&
            vals.has('rating_system_id') && vals.get('rating_system_id') && vals.get('rating_system_id') === v.rating_system_id &&
            vals.has('platform') && vals.get('platform') && vals.get('platform') === v.platform
          ) {
            error.push(store.__('Rating must be unique, region in duplicated.'))
          }
        }
      })

      return error.length > 0 ? error : undefined
    }
  }
})
